export default "__VITE_ASSET__CryxtkqR__"